import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import {withRouter} from "react-router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as CONFIG from './_config';
import ls from "local-storage";

const axios = require('axios');

class SimpleSlider extends Component {

    render() {
        function SampleNextArrow(props) {
            const { className, style, onClick } = props;
            return (
                <div
                    className={className}
                    style={{ ...style, display: "block"}}
                    onClick={onClick}
                />
            );
        }

        function SamplePrevArrow(props) {
            const { className, style, onClick } = props;
            return (
                <div
                    className={className}
                    style={{ ...style, display: "block" }}
                    onClick={onClick}
                />
            );
        }


        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            adaptiveHeight: true,
            appendDots: dots => (
                <div>
                    <ul style={{ margin: "0px" }}> {dots} </ul>
                </div>
            ),
            customPaging: i => (
                <div
                    style={{
                        display: "inline-block",
                        border: "3px solid",
                        color: CONFIG.DATA.LOGO_COLOR || "#95a83f",
                        fontFamily: "roboto",
                        fontSize: "11pt",
                        fontWeight: "bold",
                        paddingTop: "5px",
                        marginRight: 7,
                        width: 40,
                        height: 40,
                        borderRadius: "50% 50%",
                        textAlign: "center",
                        textDecoration: "none"
                    }}
                >
                    {i + 1}
                </div>
            ),
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]

        };
        return (
            <Slider {...settings}>
                {this.props.sliders.map((value, index) => (
                    <div key={index}>
                        <div>
                            <img 
                            style={{}} 
                            src={value.URL} 
                            alt="Tutorial" 
                            className="weekly-ad-img" 
                            />
                        </div>
                    </div>
                ))}

            </Slider>
        );
    }
}

class Tutorial extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    };



    componentDidMount() {
       ls.set('redirectTo',window.location.href);
    }


    render() {
        var routeName = 'How to shop online?'
        const imageName = this.props.match.params.image||'';
        const ImageObj = {};
        ImageObj.URL = '/assets/videos/'+imageName;
        const ImageList = [];
        ImageList.push(ImageObj);

        console.log(imageName, ImageList);

    return (
        <div className="main-container full-width pt-5 mt-5">

            {CONFIG.DATA.THEME == 2 ?
                <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb"
                         style={{backgroundColor: '#f3ffd9'}}>
                    <div className="container">
                        <div className="wrapper-breads">
                            <div className="wrapper-breads-inner">
                                <div className="breadscrumb-inner text-center">
                                    <h2 className="bread-title">{routeName}</h2>
                                    <ol className="breadcrumb ml-5 ">
                                        <li><a href="/">Home</a></li>
                                        <li><span className="active">{routeName}</span></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                :
                <div className="title-breadcrumb">
                    <div className="container">
                        <div className="title-breadcrumb-inner">
                            <header className="entry-header">
                                <h1 className="entry-title">{routeName}</h1>
                            </header>
                            <div className="breadcrumbs"><Link to="/">Home</Link><span
                                className="separator">/</span><span>{routeName}</span></div>
                        </div>
                    </div>

                </div>
            }

            {CONFIG.DATA.THEME == 2 ?
                <section id="main-container" className="container inner">
                    <div className="row">
                        <div id="main-content" className="main-page col-xs-12 clearfix">
                            <main id="main" className="site-main" role="main">
                                <h1>Coming soon</h1>
                            </main>
                            {/* .site-main */}
                        </div>
                        {/* .content-area */}
                    </div>
                </section>
                :
                <div className='container'>
                    <div className="row">
                        {
                            imageName && imageName != ''
                            ?
                            <div className="col-lg-12">
                                    <div className='text-center py-3'>
                                        <Link style={{color:'blue'}} to={'/tutorial'}>click here for online shopping instructions or watch this quick tutorial video</Link>
                                    </div>
                                    <figure className="thumnail weekly1" style={{minHeight:500}}>
                                        <img src={'/assets/videos/'+imageName} alt="Tutorial" className="weekly-ad-img" />
                                    </figure>
                                </div>
                            :
                            <div className="vc_col-xs-12">
                            <div className="page-content default-page">
                                <article className="post-8436 page type-page status-publish hentry">
                                    <div className="entry-content">
                                        <div className="vc_row wpb_row vc_row-fluid">
                                            <div className="row-container"
                                                 style={{ /*marginLeft:'25%',*/ marginTop: '0px'}}>
                                                <div className="wpb_column vc_column_container vc_col-sm-2">
                                                    <div className="vc_column-inner">
                                                        <div className="wpb_wrapper"></div>
                                                    </div>
                                                </div>
                                                <div className="wpb_column vc_column_container vc_col-sm-8">
                                                    <div className="vc_column-inner">
                                                        <div className="wpb_wrapper text-left">
                                                            <div className='text-center py-3'>
                                                                <Link style={{color:'blue'}} to={'/tutorial/'+ CONFIG.DATA.TUTORIAL_INSTRUCTION_IMAGE}>click here for online shopping instructions or watch this quick tutorial video</Link>
                                                            </div>
                                                            <Video  loop /*autoPlay muted*/
                                                                controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
                                                                poster={CONFIG.DATA.TUTORIAL_VIDEO_THUMB}
                                                                onCanPlayThrough={() => {
                                                                    // Do stuff
                                                                }}>
                                                                <source src={CONFIG.DATA.TUTORIAL_VIDEO_MP4} type="video/mp4" />
                                                                {/* <track label="English" kind="subtitles" srcLang="en" src="http://source.vtt" default /> */}
                                                            </Video>
                                                            <div className="vc_empty_space" style={{height: '32px'}}>
                                                                <span className="vc_empty_space_inner"></span>
                                                            </div>
                                                            <div className="description" style={{color:'#000'}} >
                                                                <span dangerouslySetInnerHTML={{__html: CONFIG.DATA.TUTORIAL_TEXT }}></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="wpb_column vc_column_container vc_col-sm-2">
                                                    <div className="vc_column-inner">
                                                        <div className="wpb_wrapper"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            }
        </div>

    )
    }
}
export default Tutorial;



